import { useEffect, useRef, useState } from 'react';

const SOURCE_IMAGE_IDS = [
    'a52712b6-da3f-4c13-a096-cad1291361b0',
    'cd60d5f9-47e2-4448-8c29-daa5223351a3',
    '8fbd5216-8a62-4d11-bb07-32f3373fb852',
    'f000ce50-bc56-4712-a452-83aa6053f257',
    'abf7898f-0266-4947-9795-780dd1d95813',
    'e729ae39-ebbe-46ad-a1e5-82195b0ecaa7',
    '25ab3974-1033-4943-9ba9-747adf9ee14e',
    'ffbb2110-84b3-428d-a587-c4679cf0a30b',
    '2f52955e-53f0-4a0f-b1af-45d03187c9e6',
    '43b95702-af3d-4e78-b1c2-886fd0ee5427',
    '2181ccca-1911-43b0-b0bb-ef1c9716176f',
    '50921d62-175b-4ec9-ae81-6b6533df5cf1',
    '3cfb4467-8c47-4e76-8a6f-7a2ec1142f41',
    '4b996eb7-976c-4007-92ac-bd4bb9e26355',
    'd6a67f25-64ab-41d6-9d44-46603f162c21',
    'dd1d9d43-766d-416a-9278-f751b8d4593e',
    'e9d6940b-5654-444c-aaab-8c5182fcc543',
    '7239c230-dc71-4eb0-b15c-f3a01dbd947c',
    'b3727450-96dc-40a9-a187-0cabe4d8e2e2',
    'a8226e47-5312-42f9-92fd-5285ca41aa63',
    '179085d7-f332-450e-bfce-eaafceeaa7d3',
    '968f2145-59ec-4219-ada8-76a997024722',
    'b2be1523-5e2d-4a1a-80f6-6d8c992473db',
    '0daaf19f-52f7-4bde-86da-157d2fdf6945',
    '57d546ba-4d43-434c-a56a-e9616fc2213d',
    '9e4be454-3799-4352-b288-c8759a713ea2',
    'f48379ff-a62a-4ced-a25d-dcc787dd3420',
    'f82232a6-0c4c-4150-b9e7-6de5f84663e1',
    '02f31801-b5d1-4a39-aeee-32063c3c3531',
    '20fe222c-a16a-4b17-8984-f3ca98f7255a',
    '60c57ea0-01f9-4e3e-a117-33c325eea61e',
    '4f3d40de-7ba9-4a7e-a8cb-891cc9159f59',
    '6b674844-a60d-4530-9406-c89c3e613999',
    'dc4fe8b9-1a00-4aff-9e5f-5336befd37f8',
    '4709ae75-8073-4428-8edf-7bf8c29b9308',
    '133f149f-0d8b-4083-98e7-5cf21aaa3c90',
    'b2953381-9450-4505-ae09-cca1bf3405a5',
    '3c8c6d08-7324-4369-b404-a95165bca5f7',
    '0b2e29cb-3c34-4ad3-aab8-4ac22d785222',
    'ee9346ab-0410-43f0-8336-f84305e8f15a',
    'c211cff4-199c-4787-ac0a-b74166257926',
    '709b00b4-9983-40e3-8907-f8a701deb1d0',
    'eea90659-e8c4-45fe-b175-513097a80c4c',
    '69da3635-a2d4-48a5-8c7a-ab0a1988c98e',
    '9ada6bb0-925e-4a7d-a868-bdc107a0b5ec',
    '07e77e26-e8ac-4244-84e6-9c9763d68588',
    '7adf9f7c-8c50-49d5-b63d-d1fee6d7acd3',
    'a20c0d84-e5b0-486e-8ecc-c72b6ff0c365',
    '66a7d58c-545b-41e6-ba84-86b8b1feefe9',
    'ee2cfc25-52f8-49eb-a669-4d1709043942',
    'e66af475-9004-457a-89dd-3345767dc4bb',
    'bfa6d1db-679d-4f4a-b583-8c542d129963',
    'b2802253-f0d4-475c-ac07-52bef39f5c57',
    'f3f13cf6-13bd-41a3-9360-a0984a0c0e1f',
    'cf4d45f4-87bd-4535-b53e-c415b8c370a0',
    'df941af3-1228-4c8a-b1a1-eeb399871510',
    'b32296ca-a5cc-48a1-bd59-79db9a2e99ee',
    '185830f2-6071-42e3-9e4a-df9373a9b3ee',
    'ecdb3375-a1a0-411b-874b-fa2db9ab9cd2',
    '6996cb87-2a7c-4c5a-845e-e0598c2d744e',
    'bf336b5c-0fbc-4b72-9f64-b63808d7197e',
    '7c948923-066c-4ae7-896a-a5f367b4beac',
    'd9e4f3a6-bd69-4acf-a087-75cfc96286ff',
    '4753cf2e-5254-4346-96fd-5af38005b886',
];

export const PODCAST_FLIPPER_ARTWORK_COUNT = 16;
export const PODCAST_FLIPPER_CHANGE_INTERVAL_MS = 850;
export const PODCAST_FLIPPER_CHANGE_FADE_MS = 180;
// The last staggered entrance animation finishes at roughly 990 ms.
export const PODCAST_FLIPPER_INITIAL_CHANGE_DELAY_MS = 1050;

const sourceImageUrl = (sourceId) =>
    `https://firebasestorage.googleapis.com/v0/b/twinklepoo/o/srcimg%2F${sourceId}.png?alt=media`;

const randomIndex = (length) => Math.floor(Math.random() * length);

const randomSourceIds = (count) => {
    const shuffled = [...SOURCE_IMAGE_IDS];

    for (let index = shuffled.length - 1; index > 0; index -= 1) {
        const swapIndex = randomIndex(index + 1);
        [shuffled[index], shuffled[swapIndex]] =
            [shuffled[swapIndex], shuffled[index]];
    }

    return shuffled.slice(0, count);
};

const nextTileIndex = (tileCount, previousIndex) => {
    if (tileCount <= 1) {
        return 0;
    }

    if (previousIndex < 0 || previousIndex >= tileCount) {
        return randomIndex(tileCount);
    }

    const candidate = randomIndex(tileCount - 1);
    return candidate >= previousIndex ? candidate + 1 : candidate;
};

export default function PodcastFlipper({ subtitle = 'Creating your feed.', embedded = false }) {
    const [sourceIds, setSourceIds] = useState(
        () => randomSourceIds(PODCAST_FLIPPER_ARTWORK_COUNT),
    );
    const [pendingChange, setPendingChange] = useState(null);
    const sourceIdsRef = useRef(sourceIds);
    const previousIndexRef = useRef(-1);
    const pendingChangeRef = useRef(null);
    const replacementSourceIdsRef = useRef(null);
    const changeIdRef = useRef(0);

    if (replacementSourceIdsRef.current === null) {
        const visibleSourceIdSet = new Set(sourceIds);
        replacementSourceIdsRef.current = randomSourceIds(
            SOURCE_IMAGE_IDS.length,
        ).filter((sourceId) => !visibleSourceIdSet.has(sourceId));
    }

    useEffect(() => {
        const reducedMotion =
            typeof window.matchMedia === 'function' &&
            window.matchMedia('(prefers-reduced-motion: reduce)')?.matches;

        if (reducedMotion) {
            return undefined;
        }

        let intervalId = null;
        const startArtworkChange = () => {
            if (pendingChangeRef.current !== null) {
                return;
            }

            const tileIndex = nextTileIndex(
                sourceIdsRef.current.length,
                previousIndexRef.current,
            );
            if (replacementSourceIdsRef.current.length === 0) {
                const visibleSourceIdSet = new Set(sourceIdsRef.current);
                replacementSourceIdsRef.current = randomSourceIds(
                    SOURCE_IMAGE_IDS.length,
                ).filter((sourceId) => !visibleSourceIdSet.has(sourceId));
            }
            const replacementSourceId =
                replacementSourceIdsRef.current.pop();

            previousIndexRef.current = tileIndex;
            const nextPendingChange = {
                changeId: changeIdRef.current,
                phase: 'preloading',
                replacementSourceId,
                tileIndex,
            };
            changeIdRef.current += 1;
            pendingChangeRef.current = nextPendingChange;
            setPendingChange(nextPendingChange);
        };

        const initialChangeTimeoutId = window.setTimeout(() => {
            startArtworkChange();
            intervalId = window.setInterval(
                startArtworkChange,
                PODCAST_FLIPPER_CHANGE_INTERVAL_MS,
            );
        }, PODCAST_FLIPPER_INITIAL_CHANGE_DELAY_MS);

        return () => {
            window.clearTimeout(initialChangeTimeoutId);
            if (intervalId !== null) {
                window.clearInterval(intervalId);
            }
            pendingChangeRef.current = null;
        };
    }, []);

    useEffect(() => {
        if (pendingChange?.phase !== 'fading') {
            return undefined;
        }

        const {
            changeId,
            replacementSourceId,
            tileIndex,
        } = pendingChange;
        const changeTimeoutId = window.setTimeout(() => {
            if (pendingChangeRef.current?.changeId !== changeId) {
                return;
            }

            const nextSourceIds = [...sourceIdsRef.current];
            nextSourceIds[tileIndex] = replacementSourceId;
            sourceIdsRef.current = nextSourceIds;
            pendingChangeRef.current = null;
            setSourceIds(nextSourceIds);
            setPendingChange(null);
        }, PODCAST_FLIPPER_CHANGE_FADE_MS);

        return () => {
            window.clearTimeout(changeTimeoutId);
        };
    }, [pendingChange]);

    const replacementImageLoaded = (event) => {
        const image = event.currentTarget;
        const changeId = Number(image.dataset.changeId);
        const replacementSourceId = image.dataset.sourceId;

        const beginFade = () => {
            const currentPendingChange = pendingChangeRef.current;
            if (
                currentPendingChange?.changeId !== changeId
                || currentPendingChange.phase !== 'preloading'
                || currentPendingChange.replacementSourceId
                    !== replacementSourceId
            ) {
                return;
            }

            const fadingChange = {
                ...currentPendingChange,
                phase: 'fading',
            };
            pendingChangeRef.current = fadingChange;
            setPendingChange(fadingChange);
        };

        if (typeof image.decode === 'function') {
            try {
                const decodeResult = image.decode();
                if (decodeResult && typeof decodeResult.then === 'function') {
                    decodeResult.then(beginFade, beginFade);
                } else {
                    beginFade();
                }
            } catch {
                beginFade();
            }
        } else {
            beginFade();
        }
    };

    const replacementImageFailed = (event) => {
        const changeId = Number(event.currentTarget.dataset.changeId);
        if (pendingChangeRef.current?.changeId !== changeId) {
            return;
        }

        pendingChangeRef.current = null;
        setPendingChange(null);
    };

    const changingIndex = pendingChange?.phase === 'fading'
        ? pendingChange.tileIndex
        : null;

    return (
        <section
            className={`podcastFlipper${embedded ? ' podcastFlipperEmbedded' : ''}`}
            aria-label={embedded ? 'Finding your highlights' : undefined}
            aria-labelledby={embedded ? undefined : 'podcast-flipper-title'}
            aria-describedby={embedded ? undefined : 'podcast-flipper-subtitle'}
        >
            {!embedded && <header className='podcastFlipperHeader'>
                <h1 id='podcast-flipper-title'>Finding your highlights</h1>
                <p id='podcast-flipper-subtitle'>
                    {subtitle}
                </p>
            </header>}

            <div className='podcastFlipperMosaic' aria-hidden='true'>
                {sourceIds.map((sourceId, index) => (
                    <img
                        key={`podcast-flipper-slot-${index}`}
                        className={[
                            'podcastFlipperArtwork podcastArtwork',
                            changingIndex === index ?
                                'podcastFlipperArtworkChanging' :
                                '',
                        ].filter(Boolean).join(' ')}
                        style={{ '--podcast-flipper-index': index }}
                        src={sourceImageUrl(sourceId)}
                        alt=''
                        decoding='async'
                        draggable='false'
                    />
                ))}
            </div>

            {pendingChange && (
                <img
                    className='podcastFlipperArtworkPreload'
                    src={sourceImageUrl(pendingChange.replacementSourceId)}
                    alt=''
                    aria-hidden='true'
                    data-change-id={pendingChange.changeId}
                    data-source-id={pendingChange.replacementSourceId}
                    decoding='async'
                    onLoad={replacementImageLoaded}
                    onError={replacementImageFailed}
                />
            )}

            <div
                className='podcastFlipperStatus'
                role='status'
                aria-live='polite'
            >
                <span className='podcastFlipperSpinner' aria-hidden='true' />
                <span className='podcastFlipperStatusText'>
                    Finding your highlights
                </span>
            </div>
        </section>
    );
}
